import React from "react";
import { createBrowserHistory } from "history";
import { Switch, Route } from "react-router";
import UserPage from "./pages/UserPage";

export const browserHistory = createBrowserHistory();

const UserRouter: React.FC = (props) => {
  return (
    <Switch>
      <Route path="/user" component={UserPage} />
    </Switch>
  );
};

export default UserRouter;
